<template>
  <div class="center">
    <div class="waitingcom_title">
      <el-form
        label-width="80px"
        :model="formLabelAlign"
        ref="formLabelAlign"
        :label-position="labelPosition"
      >
        <el-form-item label="姓名：" prop="userName">
          <el-input
            v-model.trim="formLabelAlign.userName"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属分组：" prop="Belongs">
          <el-select v-model="formLabelAlign.Belongs" placeholder="全部">
            <el-option
              v-for="item in BelongsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="创建时间：" prop="examBeginDate">
          <div class="block">
            <el-date-picker
              @change="searchChang"
              v-model="formLabelAlign.examBeginDate"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div class="query_btn">
        <el-button
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          @click="search"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          @click="resetForm('formLabelAlign')"
          >重置</el-button
        >
      </div>
    </div>
    <!-- 操作按钮 -->
    <div class="operation_btn">
      <el-button @click="addPersonnel()">
        <i class="iconfont icon-action-add-hover"></i>添加人员
      </el-button>
      <!-- <el-button> <i class="iconfont icon-daochu"></i>导出 </el-button> -->
      <el-button @click="deleteDataArr">
        <i class="iconfont icon-batch-shanchu"></i>批量删除
      </el-button>
    </div>
    <!-- 表单内容 -->
    <div class="form_mian" v-loading="isLoading">
      <el-table
        ref="tabledata"
        :data="getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :row-key="getRowKeyOfTarget"
        @row-click="StepsListRowClick"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column
          type="selection"
          width="80"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (pageIndex - 1) * eachPageNum }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <div @click.stop="">
              <el-switch
                v-model="scope.row.IsLock"
                @change="freezeBtn(scope.row)"
                active-color="#1890FF"
                inactive-color="#ff4949"
                :active-value="0"
                :inactive-value="1"
              >
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="320">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                type="text"
                size="small"
                @click.stop="settingData(scope.row)"
                >权限设置</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="compileData(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="resetPaw(scope.row)"
                >重置密码</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="deleteData(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="foot_box">
        <div class="foot_pagetions">
          <!-- <p>
            共有{{ total }}条记录，当前第{{ pageIndex + 1 }}/{{ pagesun }}页
          </p> -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="showpageindex"
            :page-size="eachPageNum"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <Popup ref="popup" :statePopupstatus="statePopupstatus" />
  </div>
</template>

<script>
import loginvuex from "@/store/index";
import systemclass from "@/api/systemclassification";
import { userlist, lockState } from "@/api/permissions.js";
import {
  authAppOne,
  authAppTwo,
  authAppThree,
  authApp,
} from "@/api/permissions.js";
import Popup from "./Popup";
import qs from "qs";
export default {
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      labelPosition: "right",
      formLabelAlign: {
        userName: "", // 姓名
        Belongs: "", // 所属分组
        examBeginDate: "", // 时间查询
        createBeginTime: "", //创建开始时间
        createEndTime: "", //创建结束时间
      },
      getDataCondition: {
        userName: "", // 姓名
      },
      BelongsOptions: [
        {
          value: "",
          label: "全部",
        },
      ],
      showpageindex: 1, //显示的索引盒子
      multipleSelection: [],
      multipleSelectionIds: [],
      multipleSelectionCount: 0,
      pagesizesarr: [5, 10, 20, 50, 100],
      pageIndex: 1, // 起始页
      eachPageNum: 10, //每页展示
      total: 100,
      pagesun: "", //一共多少页
      getData: [], //列表数据源
      isLoading: true,
      formColumns: [
        {
          prop: "username",
          label: "账号",
          // width: "240px",
        },
        {
          prop: "RealName",
          label: "姓名",
          // width: "240px",
        },
        {
          prop: "AuthClass",
          label: "科室权限",
          width: "240px",
        },
        {
          prop: "Telephone",
          label: "手机号码",
        },
        {
          prop: "CreateTime",
          label: "创建时间",
        },
        {
          prop: "LastLoginDate",
          label: "最后登录时间",
        },
      ],
      thawState: true, //临时状态开关
      statePopupstatus: "", // 当前的row
    };
  },
  props: ["cutcoms"],
  components: {
    Popup,
  },
  methods: {
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    // chang搜索
    searchChang() {
      this.isLoading = true;
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      if (this.formLabelAlign.examBeginDate == null) {
        this.formLabelAlign.createBeginTime = "";
        this.formLabelAlign.createEndTime = "";
      }
      this.getDataList();
    },
    // 重置
    resetForm(formExamin) {
      this.Buriedpoint(
        {
          code: "Webmaster:Personnel:rest",
          parent_code: "Webmaster:Personnel",
        },
        "statetime"
      );
      this.isLoading = true;
      this.$refs[formExamin].resetFields();
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.showpageindex = 1;
      this.isLoading = true;
      this.getDataCondition.userName = "";
      this.formLabelAlign.examBeginDate = "";
      this.formLabelAlign.createBeginTime = "";
      this.formLabelAlign.createEndTime = "";
      this.pageIndex = 1;
      this.getDataList();
      // this.reqcurrentPage3 = 0;
      //   this.pageIndex = 0;
      //   this.getDatalist();
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 搜索
    search() {
      this.Buriedpoint(
        {
          code: "Webmaster:Personnel:search",
          parent_code: "Webmaster:Personnel",
        },
        "statetime"
      );
      this.isLoading = true;
      this.pageIndex = 1;
      this.$refs.tabledata.clearSelection();
      if (this.formLabelAlign.userName) {
        this.getDataCondition.userName = this.formLabelAlign.userName;
      } else {
        this.getDataCondition.userName = "";
      }
      this.getDataList();
    },
    // 列表
    async getDataList() {
      if (this.formLabelAlign.examBeginDate) {
        const time = JSON.parse(
          JSON.stringify(this.formLabelAlign.examBeginDate)
        );
        this.formLabelAlign.createBeginTime = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.createEndTime = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      let res = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        userbutton: "", // 账号
        pageSize: this.eachPageNum, // 每页条数
        pageIndex: this.pageIndex - 1, // 起始页
        userbutton: this.getDataCondition.userName, // 查询
        beginCreateTime: this.formLabelAlign.createBeginTime, //开始时间
        endCreateTime: this.formLabelAlign.createEndTime, // 结束时间
      };
      const Data = await userlist(qs.stringify(res));
      if (Data.status === 200) {
        this.getData = Data.data.Data.data;
        this.total = Data.data.Data.count;
        this.pagesun = Data.data.Data.pageCount;
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        this.dealData();
      } else {
        this.$message.error("数据异常");
      }
      console.log(Data.data.Data.data, "权限列表页");
    },
    handleSelectionChange(rows) {
      //   this.multipleSelection = val; // 批量删除多选状态
      // 初始化全局表格多选框
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      // 将数据存入
      rows.forEach((row) => {
        this.multipleSelectionIds.push(row.userid);
      });
      this.multipleSelection = rows;
      this.multipleSelectionCount = this.multipleSelection.length;
      console.log(this.multipleSelectionIds, "<<=====multipleSelectionIds");
      console.log(this.multipleSelection, "<<=====multipleSelection");
      console.log(this.multipleSelectionCount, "<<=====multipleSelectionCount");
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.eachPageNum = val;
      this.isLoading = true;
      this.getDataList(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.isLoading = true;
      this.getDataList(); // 重新发起请求
    },
    // 权限设置
    settingData(row) {
      localStorage.setItem("isreload", true);
      this.Buriedpoint({
        code: "Webmaster:Personnel:permissions",
        parent_code: "Webmaster:Personnel",
      });
      this.$parent.currentRow = row;
      this.cutcoms(1);
    },
    // 编辑
    compileData(row) {
      this.Buriedpoint(
        {
          code: "Webmaster:Personnel:edit",
          parent_code: "Webmaster:Personnel",
        },
        "statetime"
      );
      this.statePopupstatus = row;
      this.$refs.popup.dialogVisibleObj.editorPopup = true;
    },
    // 重置密码
    resetPaw(row) {
      this.Buriedpoint(
        {
          code: "Webmaster:Personnel:restPassword",
          parent_code: "Webmaster:Personnel",
        },
        "statetime"
      );
      this.statePopupstatus = row;
      this.$refs.popup.deleteState = 3; //重置
      this.$refs.popup.dialogVisibleObj.deletePopup = true;
    },
    // 删除
    deleteData(row) {
      this.Buriedpoint(
        {
          code: "Webmaster:Personnel:delete",
          parent_code: "Webmaster:Personnel",
        },
        "statetime"
      );
      this.statePopupstatus = row;
      this.$refs.popup.deleteState = 0;
      this.$refs.popup.dialogVisibleObj.deletePopup = true;
    },
    // 批量删除
    deleteDataArr() {
      this.Buriedpoint(
        {
          code: "Webmaster:Personnel:batchDelete",
          parent_code: "Webmaster:Personnel",
        },
        "statetime"
      );
      if (this.multipleSelectionIds == "") {
        this.$refs.popup.deleteState = 2;
        this.$refs.popup.dialogVisibleObj.deletePopup = true;
      } else {
        this.$refs.popup.deleteState = 1;
        this.$refs.popup.dialogVisibleObj.deletePopup = true;
      }
    },
    // 数据处理
    dealData() {
      this.getData.map((item) => {
        for (let ztiem in item) {
          if (item[ztiem] === "" || item[ztiem] === null) {
            item[ztiem] = "未设置";
          }
        }
      });
    },
    // 冻结
    async freezeBtn(row) {
      this.Buriedpoint(
        {
          code: "Webmaster:Personnel:status",
          parent_code: "Webmaster:Personnel",
        },
        "statetime"
      );
      let res = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        IsLock: row.IsLock,
        UserID: row.userid,
      };
      let text = row.IsLock === 0 ? "冻结" : "解冻";
      this.$confirm(
        "确认要" + text + '"' + row.RealName + '"' + "用户吗?",
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          const Data = await lockState(res);
          if (Data.status === 200) {
            this.$message({
              message: "恭喜你" + Data.data.Data,
              type: "success",
            });
          }
        })
        .then(() => {
          // this.$message({
          //   type: "success",
          //   message: text + "成功",
          // });
        })
        .catch(() => {
          row.IsLock = row.IsLock === 0 ? 1 : 0;
          this.$message({
            type: "info",
            message: "已取消" + text,
          });
        });

      // console.log(Data.data.Data);
    },
    // 添加人员
    addPersonnel() {
      this.Buriedpoint(
        { code: "Webmaster:Personnel:add", parent_code: "Webmaster:Personnel" },
        "statetime"
      );
      this.$refs.popup.dialogVisibleObj.addPersonnel = true;
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.userid;
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    async settestbank() {
      if (localStorage.getItem("alltestbank")) {
        this.$parent.testdata = JSON.parse(localStorage.getItem("alltestbank"));
        return;
      }
      let date = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
        studentUserID: this.getData[0].userid, //这里先写一个假的
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
      };
      let resr = await authApp(date);
      // let testAppOne = resr.data.Data; //获取到的第一级列表
      // for (let x = 0; x < testAppOne.length; x++) {
      //   date.pid = testAppOne[x].AppClassID; //获取到父第一级ID
      //   let resrTwo = await authAppTwo(date); //请求到第二级全部列表
      //   let testAppTwo = resrTwo.data.Data; //获取到第二级
      //   // console.log(testAppTwo);
      //   for (let i = 0; i < testAppTwo.length; i++) {
      //     let date1 = {
      //       userID: JSON.parse(loginvuex.state.userlist).userID,
      //       guid: JSON.parse(loginvuex.state.userlist).guid,
      //       hid: JSON.parse(loginvuex.state.userlist).hid,
      //       studentUserID: this.getData[0].userid, //这里先写一个假的
      //       pid: testAppTwo[i].AppClassID,
      //     };
      //     let resrThree = await authAppThree(date1);
      //     // console.log('第'+i+'次');
      //     resrThree.data.Data.map((item) => {
      //       item.AppClassName = item.AppName;
      //       return item;
      //     });
      //     testAppTwo[i].children = resrThree.data.Data;
      //   }
      //   testAppOne[x].children = testAppTwo;
      // }
      // console.log(testAppOne);
      localStorage.setItem("alltestbank", JSON.stringify(resr.data.Data));
    },
  },
  async created() {
    this.stateArr = [];
    await this.getDataList();
    // this.settestbank(); // 2023.6.19 取的死数据 删除
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang="scss" scoped>
.center {
  height: 100%;
  width: 100%;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 14px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  // justify-content: space-between;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  ::v-deep .el-form-item__content {
    margin-left: 115px !important;
  }
}
::v-deep.el-form {
  display: flex;
  div:nth-child(1) {
    .el-form-item__label {
      margin: 0 !important;
      text-align: center;
    }
    .el-form-item__content {
      margin-left: 87px !important;
    }
  }
  ::v-deep .el-input > .el-input__inner {
    width: 200px;
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
// 操作按钮
.operation_btn {
  display: flex;
  align-items: center;
  padding: 0px 24px;
  height: 74px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
    width: 104px;
    height: 40px;
    &:nth-child(1) {
      background: #1890ff;
    }
    // &:nth-child(2) {
    //   background: #64b5ff;
    //   width: 88px;
    // }
    &:nth-child(2) {
      background: #e54d4d;
    }
  }
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
.form_mian {
  margin-top: 24px;
  padding: 0px 24px;
  min-height: 560px;
  ::v-deep .el-table th:nth-child(1) {
    opacity: 1;
    border-radius: 4px 0px 0px 4px;
  }
  ::v-deep .el-table th:nth-child(10) {
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
  }
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
  }
  ::v-deep .el-button--text {
    font-size: 16px;
  }
  ::v-deep.el-table .cell {
    text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  }
}
</style>